export default "__VITE_ASSET__CLLkvV2Z__"